/** @jsxImportSource @emotion/react */
import React, { ChangeEventHandler } from 'react'
import { Box, Icon, Input } from '@gousto-internal/citrus-react'
import { Spinner } from 'goustouicomponents/dist'
import { useNavigateToSearchPage } from '../../hooks'
import { HelpCentre } from '../../common/tracking'

type SearchBarProps = {
  isLoading?: boolean
  onChange?: ChangeEventHandler<HTMLInputElement>
  initValue?: string
}

const SearchBar = ({
  isLoading = false,
  onChange,
  initValue,
}: SearchBarProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const goToSearch = useNavigateToSearchPage()

  return (
    <form
      css={{ width: '100%' }}
      onSubmit={(e) => {
        e.preventDefault()
        goToSearch(inputRef.current?.value)
      }}
    >
      <Input
        leftAccessory={<Icon name="search" />}
        placeholder="Search for help"
        rightAccessory={isLoading && (
          <Box paddingRight={3}>
            <Spinner color="black" />
          </Box>
        )}
        onChange={onChange}
        defaultValue={initValue}
        ref={inputRef}
        data-tracking-action={HelpCentre.HELP_CENTRE_SEARCH_CLICK}
        data-tracking-property={JSON.stringify({ search_term: inputRef.current?.value })}
      />
    </form>
  )
}

export { SearchBar }
